import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit/colors';
import { SubwayInfo as SubwayInfoComponent } from '../../components/SubwayInfo';
import { ISubwayInfo } from '../../types/subway';
import { metroIconMap, transportIconMap } from './helpers';

type TThemeType = 'standard' | 'light';

interface ISubwayInfoProps {
  subwayInfo?: ISubwayInfo | null;
  theme?: TThemeType;
}

const titleThemeMap: Record<TThemeType, TColors> = {
  standard: 'black_100',
  light: 'white_100',
};

const timeThemeMap: Record<TThemeType, TColors> = {
  standard: 'gray60_100',
  light: 'white_60',
};

export function SubwayInfo({ subwayInfo, theme = 'standard' }: ISubwayInfoProps) {
  if (!subwayInfo) {
    return null;
  }

  const TransportIcon = transportIconMap[subwayInfo.transportType];
  const MetroIcon = metroIconMap.default;

  return (
    <SubwayInfoComponent
      subwayIcon={<MetroIcon color={subwayInfo.lineColor as TColors} />}
      subwayColor={`#${subwayInfo.lineColor}`}
      title={<ArticleParagraph2 color={titleThemeMap[theme]}>{subwayInfo.name}</ArticleParagraph2>}
      typeIcon={<TransportIcon />}
      time={<ArticleParagraph2 color={timeThemeMap[theme]}>{subwayInfo.timeDisplay}</ArticleParagraph2>}
    />
  );
}
